'use strict';

import { passwordCheckElements } from "./elements/passwordCheckElements";

export default class PasswordCheck
{
    constructor() {
        this.elements = passwordCheckElements();

        this.focusPasswordOne = this.onFocusPasswordOne.bind(this);

        this.addEventListeners();
    }

    addEventListeners() {
        // Hmm, does not seem to work
        this.elements.passwordOne.addEventListener('focusin', this.focusPasswordOne);
    }

    onFocusPasswordOne() {
        console.log('FOCUSSSS');
    }
}
